export default __webpack_public_path__ + "static/media/code-blur.2e83f356.png";